var render, staticRenderFns
import script from "./DlgGridHelpBox.vue?vue&type=script&lang=js&"
export * from "./DlgGridHelpBox.vue?vue&type=script&lang=js&"
import style0 from "./DlgGridHelpBox.vue?vue&type=style&index=0&id=5608d556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608d556",
  null
  
)

export default component.exports